import {
    mappingArray
} from './mapping.js'
export default {
    install (Vue, options) {
        Vue.prototype._languageTransfer = function (data) {
            // console.log(data)
            return data.map(e => {
                return mappingArray.filter(i => i.db === e)[0]
            })
        }
    }
}
